import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { config } from '@uhg-abyss/web/tools/config';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { UHCProviderLink } from '@src/common/UHCProviderLink';
import { UHCLink } from '@src/common/UHCLink';
import { useUser } from '@src/state/user';
import { LagoonContext } from '@src/AppContext/LagoonContext';

const MainContainer = styled('div', {
  border: '1px solid rgb(219, 219, 219)',
  background: '$white',
  padding: '25px',
  marginBottom: '20px',
});

const BoxHeader = styled('div', {
  position: 'relative',
  marginBottom: '10px',
});

const BoxHeaderText = styled('h3', {
  fontWeight: 600,
  fontSize: '24px',
  width: '100%',
  color: '$primary1',
  fontFamily: '$heading',
});

const Description = styled('p', {
  fontSize: '16px',
  fontWeight: 500,
  marginBottom: '10px',
  fontFamily: '$primary',
});

export const WaitingView = () => {
  const { isAPIMarketPlaceUser } = useUser.state();

  const lagoonContext = React.useContext(LagoonContext);
  const uiMessages = lagoonContext.getTable('ui-messaging');
  return (
    <React.Fragment>
      <MainContainer>
        <IconBrand
          icon="clock"
          style={{ width: '72px', height: '72px' }}
          variant="twotone"
        />
        <BoxHeader>
          <BoxHeaderText>
            Your Security Key is on the way. Please allow for up to 10 business
            days.
          </BoxHeaderText>
        </BoxHeader>
        <Description>
          Once you receive the Security Key in the mail, please come back and
          complete your registration.
        </Description>
      </MainContainer>
      <Flex>
        <Flex.Content space-50>
          {isAPIMarketPlaceUser ? (
            <UHCLink
              label="Return to API Marketplace"
              url={
                uiMessages.getRow('API_MARKETPLACE_WELCOME_URL')?.message ||
                config('API_MARKETPLACE_WELCOME_URL')
              }
              sameTab
            />
          ) : (
            <UHCProviderLink
              label="Return to Provider Portal"
              url={uiMessages.getRow('SDE_URL')?.message || config('SDE_URL')}
            />
          )}
        </Flex.Content>
      </Flex>
    </React.Fragment>
  );
};

WaitingView.propTypes = {};
